export default __webpack_public_path__ + "static/char-v-29-5a58d7052942c2464da747d7adfd36ec.png";